import {React, useCallback} from 'react'
import './pages.css'
import * as AiIcons from 'react-icons/ai'
import * as DiIcons from 'react-icons/di'
import * as SiIcons from 'react-icons/si'
import * as FaIcons from 'react-icons/fa'
import * as TbIcons from 'react-icons/tb'
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";
const Skills = () => {

    const particlesInit = useCallback(async (engine) => {
        console.log(engine);
        // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
        // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
        // starting from v2 you can add only the features you need reducing the bundle size
        await loadFull(engine);
    }, []);

    const particlesLoaded = useCallback(async (container) => {
        await console.log(container);
    }, []);

    return (
        <div style={{display: 'flex', flexDirection: 'column',justifyContent: 'flex-start', alignItems: 'center', height: '90vh', backgroundColor: '#040c33', zIndex: 10, marginTop: '5%' }}>
            <div class="fade-in-text2">
                <h1 className='header'>Skills</h1>
                <div class="reveal-text">
                  <p className='sub' style={{paddingRight: '20px'}}>Front End Frameworks:</p>
                  <div className='icons'>
                    <div className='icon'>
                      
                        <FaIcons.FaReact size ={70} />
                        <p className='sub' style={{fontSize: '15px' }}>React</p>
                    </div>
                    <div className='icon'>
                        <FaIcons.FaAngular size ={70} />
                        <p className='sub' style={{fontSize: '15px' }}>Angular</p>
                    </div>
                    <div className='icon'>
                      <AiIcons.AiFillHtml5 size ={70} />
                      <p className='sub' style={{fontSize: '15px' }}>HTML</p>
                  </div>
                  <div className='icon'>
                      <SiIcons.SiCss3 size ={70} />
                      <p className='sub' style={{fontSize: '15px' }}>CSS</p>
                  </div>
                  <div className='icon'>
                      <SiIcons.SiJavascript size ={70} />
                      <p className='sub' style={{fontSize: '15px' }}>JavaScript</p>
                  </div>
                  <div className='icon'>
                      <SiIcons.SiTypescript size ={70} />
                      <p className='sub' style={{fontSize: '15px' }}>Typescript</p>
                  </div>
                </div>
                </div>
                <div class="reveal-text">
                  <p className='sub' style={{paddingRight: '20px'}}>Back End Frameworks:</p>

                  <div className='icons'>
                    <div className='icon'>
                        <DiIcons.DiMysql size ={70} />
                        <p className='sub' style={{fontSize: '15px' }}>MySQL</p>
                    </div>
                    <div className='icon'>
                        <DiIcons.DiPostgresql size ={70} />
                        <p className='sub' style={{fontSize: '15px' }}>PostgreSQL</p>
                    </div>
                    <div className='icon'>
                        <SiIcons.SiFirebase size ={70} />
                        <p className='sub' style={{fontSize: '15px' }}>Firebase</p>
                    </div>
                </div>
                </div>
                <div class="reveal-text">
                  <p className='sub' style={{paddingRight: '20px'}}>Languages:</p>

                  <div className='icons'>
                    <div className='icon'>
                        <FaIcons.FaPython size ={70} />
                        <p className='sub' style={{fontSize: '15px' }}>Python</p>
                    </div>
                    <div className='icon'>
                        <DiIcons.DiJava size ={70} />
                        <p className='sub' style={{fontSize: '15px' }}>Java</p>
                    </div>
                    <div className='icon'>
                        <DiIcons.DiPhp size ={70} />
                        <p className='sub' style={{fontSize: '15px' }}>PHP</p>
                    </div>
                    <div className='icon'>
                        <p className='sub' style={{fontSize: '25px' }}>C</p>
                    </div>
                    <div className='icon'>
                        <p className='sub' style={{fontSize: '25px' }}>C++</p>
                    </div>
                </div>
                </div>
                <div class="reveal-text">
                  <p className='sub' style={{paddingRight: '20px'}}>Mobile Development:</p>

                  <div className='icons'>
                    <div className='icon'>
                        <SiIcons.SiAndroidstudio size ={70} />
                        <p className='sub' style={{fontSize: '15px' }}>Android Studio</p>
                    </div>
                    <div className='icon'>
                        <TbIcons.TbBrandReactNative size ={70} />
                        <p className='sub' style={{fontSize: '15px' }}>React Native</p>
                    </div>
                </div>
                </div>


            </div>
            <div class="fade-in-text2">

            </div>

            <div class="fade-in-text2">


                
             </div>

             
            
        <Particles
            id="tsparticles"
            init={particlesInit}
            loaded={particlesLoaded}
            options={{
                background: {
                    color: {
                        value: "#040c33",
                    },
                },
                fpsLimit: 120,
                interactivity: {
                    events: {
                        onClick: {
                            enable: true,
                            mode: "push",
                        },
                        onHover: {
                            enable: true,
                            mode: "repulse",
                        },
                        resize: true,
                    },
                    modes: {
                        push: {
                            quantity: 4,
                        },
                        repulse: {
                            distance: 100,
                            duration: 0.4,
                        },
                    },
                },
                particles: {
                    color: {
                        value: "#ffffff",
                    },
                    links: {
                        color: "#714d97",
                        distance: 150,
                        enable: true,
                        opacity: 0.5,
                        width: 1,
                    },
                    collisions: {
                        enable: false,
                    },
                    move: {
                        directions: "none",
                        enable: true,
                        outModes: {
                            default: "bounce",
                        },
                        random: false,
                        speed: 2,
                        straight: false,
                    },
                    number: {
                        density: {
                            enable: true,
                            area: 800,
                        },
                        value: 80,
                    },
                    opacity: {
                        value: 0.5,
                    },
                    shape: {
                        type: "circle",
                    },
                    size: {
                        value: { min: 1, max: 5 },
                    },
                },
                detectRetina: true,
            }}
        />
        </div>
    )
}

export default Skills